export const SELECT = 'SELECT_DIAGNOSES';
export const REMOVE = 'REMOVE_DIAGNOSES';
export const ORDER = 'ORDER_DIAGNOSES';
export const DEFAULT = 'DEFAULT_DIAGNOSES';
export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_DIAGNOSES';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_DIAGNOSES';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_DIAGNOSES';

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}
